import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";

import { HttpOptionsBuilder } from "../../definitions/api/http-options-builder";
import { OnOrbit } from "../../definitions/api/on-orbit/on-orbit";
import { OnOrbitParams } from "../../definitions/api/on-orbit/on-orbit-params";
import { AppConfigService } from "../app.config.service";
import { ApiService } from "./api.service";
import { BaseApiService } from "./base-api.service";

@Injectable({ providedIn: "root" })
export class OnOrbitService extends BaseApiService {
	constructor(
		private api: ApiService,
		appConfigService: AppConfigService
	) {
		super("mpapi/onorbit", appConfigService.getConfigValue("API_ENDPOINT"));
	}

	onorbit(params?: OnOrbitParams): Observable<OnOrbit[]> {
		const ob = HttpOptionsBuilder.builder();
		if (params?.q) {
			ob.param("q", params.q);
		}
		if (params?.orbitRegime) {
			ob.param("orbitRegime", params.orbitRegime);
		}
		if (params?.countryCode) {
			ob.param("countryCode", params.countryCode);
		}
		if (params?.objectType) {
			ob.param("objectType", params.objectType);
		}
		if (params?.firstResult != null) {
			ob.param("firstResult", String(params.firstResult));
		}
		if (params?.maxResults != null) {
			ob.param("maxResults", String(params.maxResults));
		}
		ob.param("sort", "satNo");
		return this.api.get<OnOrbit[]>(this.url(), "errors.get-on-orbit-objects-failed", ob.build());
	}

	forOrder(orderId: string): Observable<OnOrbit[]> {
		return this.api.get(this.url(`/order/${orderId}`), undefined);
	}

	/**
	 * Looks up catalog records for specific satellite numbers via POST /onorbit/lookup
	 * (JSON body), avoiding URL-length limits on large satNo lists.
	 */
	bySatNos(satNos: number[]): Observable<OnOrbit[]> {
		const unique = [...new Set(satNos)].filter((no) => no != null);
		if (unique.length === 0) {
			return of<OnOrbit[]>([]);
		}
		return this.api.post<OnOrbit[]>(
			this.url("/lookup"),
			{ satNos: unique },
			"errors.get-on-orbit-objects-failed"
		);
	}
}
